import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { getPaletteColor, Flex } from 'pcln-design-system'
import DeltaFreeMessaging from '../../DeltaFreeMessaging'
import FreeCancellation from '../../FreeCancellation'

const BottomZone = styled(Flex)`
  border: solid ${getPaletteColor('border.base')} 1px;
  border-top-width: 0px;
  border-radius: 0px 0px 6px 6px;
`

const ItineraryShelfBottomZone = ({ showDeltaFreeMessaging, freeCancellationMessage }) => (
  <BottomZone pl={3} pt={2} pb={2} key={'bottom-zone'} width={'100%'}>
    {freeCancellationMessage && (
      <FreeCancellation message={freeCancellationMessage} messageClass={'free-cancellation-message'} />
    )}
    {showDeltaFreeMessaging && <DeltaFreeMessaging />}
  </BottomZone>
)

ItineraryShelfBottomZone.propTypes = {
  showDeltaFreeMessaging: PropTypes.bool,
  freeCancellationMessage: PropTypes.string,
}

export default ItineraryShelfBottomZone
